module.exports = __webpack_public_path__ + "/e18912ae8473d1dc330175acff10f30e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/integrations/assets/slack.svg
 ** module id = 1613
 ** module chunks = 0
 **/